import type { Props } from './Svg'
import { Svg } from './Svg'

export function WaterIcon(props: Props) {
  return (
    <Svg strokeWidth="2.4" {...props}>
      <path d="M2.257 5.032c3.055-2.667 6.594-2.667 9.6 0 3.055 2.667 6.594 2.667 9.6 0m-19.2 6.788c3.055-2.667 6.594-2.667 9.6 0 3.055 2.667 6.594 2.667 9.6 0m-19.2 6.836c3.055-2.666 6.594-2.666 9.6 0 3.055 2.667 6.594 2.667 9.6 0" />
    </Svg>
  )
}
